import { A } from '@solidjs/router';
import { For, type JSX } from 'solid-js';

// A tab rail whose "panels" are routes: a `nav` of router links, NOT a
// `role="tablist"`. A link tab navigates — the URL changes, Back works, the
// sub-page is shareable — and `role="tab"` would promise arrow-key focus and an
// in-page tabpanel that navigation never provides. The current section is
// `aria-current="page"`, which router `<A end>` sets on the exact match (so the
// section at the bare path is not also "current" under every sub-path), and
// `is-active` raises the underline.

export type LinkTabItem = {
  readonly href: string;
  /** Already translated. */
  readonly label: string;
  /** Rendered after the label inside the link (a count). */
  readonly trail?: () => JSX.Element;
};

export type LinkTabsProps = {
  /** The nav's accessible name, already translated. */
  readonly label: string;
  readonly items: readonly LinkTabItem[];
};

export function LinkTabs(props: LinkTabsProps): JSX.Element {
  return (
    <nav class="tabs__list" aria-label={props.label}>
      <For each={props.items}>
        {(item) => (
          <A class="tabs__tab" activeClass="is-active" href={item.href} end>
            {item.label}
            {item.trail?.()}
          </A>
        )}
      </For>
    </nav>
  );
}
